import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const externalTestLocaleModule: LocaleModule = {
  name: "externalTest",
  messages: { en: en, it: it },
};
